import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=760f95af&scoped=true"
import script from "./Index.vue?vue&type=script&setup=true&lang=ts"
export * from "./Index.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Index.vue?vue&type=style&index=0&id=760f95af&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760f95af",
  null
  
)

export default component.exports